/**
 * FXFilters — hidden SVG filter defs used by the liquid dissolve and
 * ripple engines (`kind: 'css'`, `data-t="dissolve"` /
 * `data-t="ripple"`). Mounted once near the page-transition stage so
 * the `data-t` rules can reference `url(#fxDissolveAF)` etc.
 *
 * `feDisplacementMap` `scale` is driven per-frame by the JS animation
 * loop in `PageTransitionStage.tsx` for `kind: 'css'` + the matching
 * data-t; this file only declares the static defs.
 */
export function FXFilters() {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
    >
      <defs>
        <filter id="fxDissolveAF" x="-20%" y="-20%" width="140%" height="140%">
          <feTurbulence
            id="fxTurbA"
            type="fractalNoise"
            baseFrequency="0.006 0.011"
            numOctaves={2}
            seed={7}
            result="noise"
          />
          <feDisplacementMap
            id="fxDissolveA"
            in="SourceGraphic"
            in2="noise"
            scale={0}
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>

        <filter id="fxDissolveBF" x="-20%" y="-20%" width="140%" height="140%">
          <feTurbulence
            id="fxTurbB"
            type="fractalNoise"
            baseFrequency="0.007 0.013"
            numOctaves={2}
            seed={23}
            result="noise"
          />
          <feDisplacementMap
            id="fxDissolveB"
            in="SourceGraphic"
            in2="noise"
            scale={0}
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>

        <filter id="fxRippleF" x="-20%" y="-20%" width="140%" height="140%">
          <feTurbulence
            id="fxTurbR"
            type="turbulence"
            baseFrequency="0.012 0.02"
            numOctaves={2}
            seed={4}
            result="noise"
          />
          <feDisplacementMap
            id="fxRipple"
            in="SourceGraphic"
            in2="noise"
            scale={0}
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
      </defs>
    </svg>
  );
}
